import { render, staticRenderFns } from "./TrackingHistory.vue?vue&type=template&id=04efda12&scoped=true"
import script from "./TrackingHistory.vue?vue&type=script&lang=js"
export * from "./TrackingHistory.vue?vue&type=script&lang=js"
import style0 from "./TrackingHistory.vue?vue&type=style&index=0&id=04efda12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04efda12",
  null
  
)

export default component.exports